import { supabase } from './supabase';

/** Unique channel name — avoids Supabase "cannot add callbacks after subscribe" errors. */
function channelName(prefix: string, id?: string) {
  return `${prefix}-${id ?? 'all'}-${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

export function subscribeTable(
  table: string,
  onChange: () => void,
  filter?: string
): () => void {
  const channel = supabase
    .channel(channelName(`dash-${table}`, filter))
    .on(
      'postgres_changes',
      { event: '*', schema: 'public', table, ...(filter ? { filter } : {}) },
      onChange
    )
    .subscribe();
  return () => {
    supabase.removeChannel(channel);
  };
}

/** Matches mobile subscribeToShiftChanges — körpass + breaks live. */
export function subscribeShiftChanges(driverId: string, onChange: () => void): () => void {
  const channel = supabase
    .channel(channelName('dash-shift', driverId))
    .on(
      'postgres_changes',
      { event: '*', schema: 'public', table: 'driving_sessions', filter: `driver_id=eq.${driverId}` },
      onChange
    )
    .on(
      'postgres_changes',
      { event: '*', schema: 'public', table: 'breaks', filter: `driver_id=eq.${driverId}` },
      onChange
    )
    .on(
      'postgres_changes',
      { event: '*', schema: 'public', table: 'trips', filter: `driver_id=eq.${driverId}` },
      onChange
    )
    .on(
      'postgres_changes',
      { event: '*', schema: 'public', table: 'session_stints', filter: `driver_id=eq.${driverId}` },
      onChange
    )
    .subscribe();
  return () => {
    supabase.removeChannel(channel);
  };
}

/** Subscribe to multiple tables — fleet-wide live sync. */
export function subscribeTables(tables: string[], onChange: () => void): () => void {
  const unsubs = tables.map((table) => subscribeTable(table, onChange));
  return () => unsubs.forEach((u) => u());
}
